import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {ContentContainer, ContentContainerProps} from "../../../components"

export const ContentContainerStyled = styled(ContentContainer)<ContentContainerProps>`
    @media (min-width: ${breakpoints.values.md}px) {
        border-right: 0.0625rem solid ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.borderColor};
        margin-left: 0;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        margin-left: ${({showSelectionHighlight}) => (showSelectionHighlight ? "0.4rem" : "0")};
        padding-bottom: ${({showSelectionHighlight}) => (showSelectionHighlight ? "1rem" : "0")};
    }
`

export const LoadingContainer = styled("div")`
    padding-top: 0.5rem;
`
